import caConsultDispatcher from '../action/caConsult';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0,
  },
  loading: false,
};

const caConsultReducer = caConsultDispatcher(initialState, {
  [caConsultDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined,
    },
  }),
  [caConsultDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value,
  }),
});

export default caConsultReducer;
